import styled from 'styled-components'
import { theme } from 'src/styles/themes/default'

type StyleMenuProps = {
  sidebar_open: boolean
}

type StyleNewHeaderProps = {
  darkTheme: boolean
  initialColor: string
  finalColor: string
  textColor: string
  buttonColor: string
  buttonCartTextColor: string
  baseColor: string
}

type ContactAreaProps = {
  textColor: string
}

export const StyleMenuMobile = styled.div<StyleMenuProps>`
  position: fixed;
  top: 0;
  right: 0;
  width: 29.625rem;
  height: 100vh;
  background-color: #ffffff;
  z-index: 10;
  padding-left: 4.625rem;
  padding-top: 2.0625rem;
  box-shadow: 0 0 1.875rem 0 rgba(0, 0, 0, 0.2);
  transform: ${(props) =>
    props.sidebar_open ? 'translateX(0%)' : 'translateX(100%)'};
  transition: all 0.3s;
  .close {
    display: flex;
    align-items: center;
    background-color: transparent;
    font-size: 0.9375rem;
    color: #2a89ff;
    margin-bottom: 4.25rem;
    img {
      margin-left: 1.1875rem;
    }
  }
  .item-menu {
    margin-bottom: 4.1875rem;
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 1.9375rem;
      img {
        margin-right: 0.9375rem;
      }
      h2 {
        font-size: 1.125rem;
        color: #363843;
        font-weight: 600;
      }
    }
    ul {
      li {
        margin-bottom: 1.5625rem;
        &:last-child {
          margin-bottom: 0;
        }
        a {
          font-size: 1rem;
          line-height: 1.0625rem;
          color: #646981;
          transition: all 0.3s;
          &:hover {
            color: #0c64d3;
            transition: all 0.3s;
          }
        }
      }
    }
  }
  .social {
    span {
      font-size: 0.875rem;
      line-height: 1.0625rem;
      color: #515568;
      display: block;
      margin-bottom: 1.4375rem;
    }
    ul {
      display: flex;
      align-items: center;
      li {
        margin-left: 0.5625rem;
        &:first-child {
          margin-left: 0;
        }
        a {
          width: 2.625rem;
          height: 2.625rem;
          background-color: #e8edf4;
          border-radius: 0.375rem;
          display: flex;
          align-items: center;
          justify-content: center;
          color: rgb(81, 85, 104);

          svg {
            font-size: 1.25rem;
          }

          span {
            font-size: 1.25rem;
            margin-bottom: 0;
          }
        }
      }
    }
  }
  @media (max-width: 68.75rem) {
    width: 100%;
    padding: 1.875rem;
    .close {
      margin-bottom: 2.5rem;
    }
    .item-menu {
      .title {
        margin-bottom: 1.25rem;
      }
      ul {
        li {
          margin-bottom: 1.25rem;
          a {
            font-size: 0.875rem;
          }
        }
      }
    }
  }
`

export const OverlayCart = styled.div`
  .overlay {
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    z-index: 99;
    opacity: 0;
    visibility: hidden;
    background: #000;
  }

  .active {
    opacity: 0.5;
    visibility: visible;
    z-index: 19;
  }
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  max-width: 81.875rem;
  width: 100%;
  padding: 0 0.9375rem;
  margin-left: auto;
  margin-right: auto;
`

export const StyleNewHeader = styled.header<StyleNewHeaderProps>`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 7.125rem;
  z-index: 1001;
  display: flex;
  align-items: center;
  background: ${(props) =>
    props.darkTheme
      ? 'linear-gradient(180deg, #0250b5 -4.51%, #141723 104.58%)'
      : (props) =>
          props.initialColor
            ? `linear-gradient(85.36deg, ${props.initialColor} 3.91%, ${props.finalColor} 98.18%)`
            : 'linear-gradient(85.36deg, #5c33ff 3.91%, #3399FF 98.18%)'};
  p,
  ul {
    margin-bottom: 0;
  }
  .theo {
    margin-left: -1.5rem;
    cursor: pointer;
  }
  .right {
    flex: 1;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.875rem;
      .welcome {
        font-size: 0.9375rem;
        line-height: 1.125rem;
        color: ${(props) =>
          props.textColor && props.textColor !== ''
            ? props.textColor
            : 'white'};
        strong {
          font-size: 0.9375rem;
          line-height: 1.125rem;
          color: ${(props) =>
            props.textColor && props.textColor !== ''
              ? props.textColor
              : 'white'};
        }
      }
      ul {
        display: flex;
        align-items: center;
        li {
          display: flex;
          align-items: center;
          margin-left: 0.8125rem;
          padding-right: 0.625rem;
          border-right: 0.0625rem solid
            ${(props) =>
              props.textColor && props.textColor !== ''
                ? props.textColor
                : 'rgba(255, 255, 255, 0.5)'};
          &:last-child {
            padding-right: 0;
            border-right: none;
          }
          &:first-child {
            span {
              font-size: 0.9375rem;
              line-height: 1.125rem;
              color: ${(props) =>
                props.textColor && props.textColor !== ''
                  ? props.textColor
                  : 'white'};
              margin-right: 0.6875rem;
            }
          }
          a {
            display: flex;
            align-items: center;
          }
          .parcela-loja {
            font-size: 0.9375rem;
            color: ${(props) =>
              props.textColor && props.textColor !== ''
                ? props.textColor
                : 'white'};
          }
          .link-pedidos {
            cursor: pointer;
            margin-left: 0.5rem;
            font-size: 0.9375rem;
            line-height: 1.125rem;
            color: ${(props) =>
              props.textColor && props.textColor !== ''
                ? props.textColor
                : 'white'};
          }
        }
      }
    }
    .geral {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .area-user {
        position: relative;
        display: flex;
        align-items: center;
        .btn-user {
          display: flex;
          align-items: center;
          img {
            width: 1.375rem;
          }
          .info-user {
            margin-left: 0.8125rem;
            span {
              text-align: left;
              display: block;
              font-size: 0.875rem;
              color: ${(props) =>
                props.textColor && props.textColor !== ''
                  ? props.textColor
                  : 'white'};
              line-height: 1;
            }
            p {
              font-size: 0.875rem;
              color: ${(props) =>
                props.textColor && props.textColor !== ''
                  ? props.textColor
                  : 'white'};
              text-align: left;
            }
          }
        }
        &.active {
          .dropdown-cadastro {
            z-index: 21;
            opacity: 1;
            top: 3.4375rem;
            pointer-events: all;
            transition: all 0.3s;
          }
        }

        .dropdown-cadastro {
          position: relative;
          background-color: #ffffff;
          box-shadow: 0 0.5rem 1.5625rem rgba(166, 166, 166, 0.2);
          border-radius: 0.375rem;
          position: absolute;
          top: 2.1875rem;
          left: 50%;
          width: 19.5rem;
          height: 13.5rem;
          margin-left: -11.0625rem;
          padding: 1.125rem 0.9375rem;
          opacity: 0;
          pointer-events: none;
          transition: all 0.3s;
          &:before {
            content: '';
            width: 0.875rem;
            height: 0.875rem;
            background-color: #ffffff;
            border-radius: 0.125rem;
            transform: rotate(-45deg);
            position: absolute;
            top: -0.3125rem;
            left: 50%;
            margin-left: -0.4375rem;
          }
          .btn-entrar {
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #6ab70a;
            border: 0.125rem solid #6ab70a;
            border-radius: 0.5rem;
            width: 100%;
            height: 3.625rem;
            text-transform: uppercase;
            color: #ffffff;
            font-weight: 600;
            margin-bottom: 1.5625rem;
            transition: all 0.3s;
            color: #ffffff;

            &:hover {
              color: #6ab70a;
              background-color: transparent;
              transition: all 0.3s;
              color: #6ab70a;
            }
          }
          .btn-cadastro {
            display: block;
            text-align: center;
            margin-bottom: 1.375rem;
            color: #646981;
            line-height: 1.4375rem;
            transition: all 0.3s;

            a {
              color: #646981;

              &:hover {
                transition: all 0.3s;
                color: $azul;
              }
            }
          }
          ul {
            display: flex;
            align-items: center;
            justify-content: center;
            border-top: 0.0625rem solid #dcdde3;
            margin-top: 1.375rem;
            padding-top: 1.375rem;
            li {
              &:first-child {
                padding-right: 1.9375rem;
                margin-right: 1.6875rem;
                border-right: 0.0625rem solid #dcdde3;
              }
              a {
                color: #646981;
                display: flex;
                align-items: center;
                height: 1.875rem;
                transition: all 0.3s;
                &:hover {
                  transition: all 0.3s;
                  color: $azul;
                }
              }
            }
          }
        }
      }
      .favoritos {
        position: relative;
      }
    }
  }
  .search {
    width: 33rem;
    height: 3rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    background-color: #f6f6f6;
    border-radius: 0.375rem;
    padding: 0;

    .controls {
      display: flex;
      width: 100%;
      border-radius: 0.375rem;
      padding: 0.25rem 0.3125rem;
    }

    input {
      flex: 1 1 auto;
      padding-right: 1rem;
      padding-left: 0.625rem;
      color: #a0a4b3;
      font-size: 0.9375rem;
      line-height: 1.125rem;
      background-color: transparent;
      &::placeholder {
        color: #a0a4b3;
      }
    }
    button {
      width: 2.5rem;
      height: 2.5rem;
      background-color: ${(props) => props.buttonColor || '#ff9d2e'};
      border-radius: 0.375rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .favoritos {
    position: relative;
    a {
      display: block;
    }
    .alert {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0.875rem;
      height: 0.875rem;
      background-color: #ff7100;
      color: #ffffff;
      border-radius: 50%;
      position: absolute;
      right: -0.125rem;
      bottom: -0.1875rem;
      font-weight: 500;
      font-size: 0.75rem;
    }
  }
  .area-cart {
    position: relative;
    &.active {
      transition: all 0.3s;
      .btn-show-cart {
        background-color: rgb(26 26 27);
        transition: all 0.3s;
      }
      .dropdown-cart {
        z-index: 21;
        opacity: 1;
        pointer-events: all;
        top: 4.0625rem;
        transition: all 0.3s;
      }
    }
    .btn-show-cart {
      background: ${(props) => props.baseColor || 'rgb(110 110 110 / 34%)'};

      border-radius: 0.375rem;
      width: 6.125rem;
      height: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;
      img {
        margin-right: 1.375rem;
      }

      span {
        color: ${(props) => props.buttonCartTextColor || theme.colors.white};
        font-size: 1.25rem;
        font-weight: 500;
      }
    }
    .dropdown-cart {
      position: absolute;
      background-color: #ffffff;
      box-shadow: 0 0.5rem 1.5625rem rgba(166, 166, 166, 0.2);
      border-radius: 0.375rem;
      width: 20.5rem;
      top: 3.75rem;
      left: -13.4375rem;
      padding: 2.375rem 1.5rem 1.625rem 1.5rem;
      opacity: 0;
      pointer-events: none;
      transition: all 0.3s;
      &:before {
        content: '';
        width: 0.875rem;
        height: 0.875rem;
        border-radius: 0.125rem;
        transform: rotate(-45deg);
        position: absolute;
        top: -0.375rem;
        right: 3.125rem;
        margin-left: -0.4375rem;
        background-color: #ffffff;
      }
      .empty-cart {
        padding: 3.125rem 0;
        img {
          margin: 0 auto;
          margin-bottom: 2.125rem;
        }
        h3 {
          text-align: center;
          color: #646981;
          font-size: 1.125rem;
          font-weight: bold;
        }
      }
      .all-prods {
        .item {
          display: flex;
          align-items: flex-start;
          padding-bottom: 1.5625rem;
          margin-bottom: 1.5625rem;
          border-bottom: 0.0625rem solid #dcdde3;

          .photo {
            box-shadow: 0 0.25rem 0.5rem rgba(71, 75, 91, 0.13);
            border-radius: 0.25rem;
            width: 3.75rem;
            height: 3.75rem;
            margin-right: 1.125rem;
            padding: 0.5rem;
          }

          .info {
            position: relative;
            flex: 1 1 auto;
            max-width: 12.5625rem;
            h3 {
              max-width: 10.1875rem;
              font-size: 0.875rem;
              line-height: 1.0625rem;
              color: #363843;
              margin-bottom: 0.75rem;
            }
            .valor-qtd {
              display: flex;
              align-items: center;
              justify-content: space-between;
              span {
                font-size: 0.8125rem;
                line-height: 1rem;
                color: #a0a4b3;
              }
              h4 {
                font-weight: 500;
                font-size: 0.8125rem;
                line-height: 1rem;
                color: #363843;
              }
            }
            button {
              position: absolute;
              top: 0.3125rem;
              right: 0;
              background-color: transparent;
              z-index: 2;
            }
          }
        }
      }
      .total {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 1.8125rem;
        span {
          margin-right: 3.4375rem;
          color: #646981;
          font-size: 0.8125rem;
        }
        h3 {
          color: #0d71f0;
          font-weight: 600;
          font-size: 0.875rem;
        }
      }
      .btn-continuar {
        width: 100%;
        height: 3.625rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #6bb70b;
        border: 0.125rem solid #6bb70b;
        border-radius: 0.5rem;
        font-weight: 600;
        letter-spacing: -0.0071rem;
        text-transform: uppercase;
        color: #ffffff;
        transition: all 0.3s;
        &:hover {
          background-color: transparent;
          color: #6bb70b;
          transition: all 0.3s;
        }
      }
    }
  }
  .area-menu {
    display: flex;
    align-items: center;
    cursor: pointer;
    span {
      font-size: 0.9375rem;
      color: #ffffff;
      margin-right: 1.125rem;
    }
  }
  .box-parcela-loja {
    display: none;

    a {
      font-size: 0.8125rem;
      color: #ffff;
    }
  }
  @media (min-width: 75.0625rem) and (max-width: 81.25rem) {
    .search {
      width: 26.75rem;
    }
  }
  @media (max-width: 75rem) {
    height: 8.625rem;
    padding: 0 1.25rem;
    ${Container} {
      height: 100%;
      padding: 0;
    }
    .theo {
      display: none;
    }
    .right {
      width: 100%;
      .top {
        display: none;
      }
      .geral {
        .logo {
          position: absolute;
          top: 0.625rem;
          max-width: 6.5625rem;
          left: 2.3125rem;
        }
        .area-user {
          position: absolute;
          top: 1.375rem;
          right: 6.875rem;
          &.active {
            .dropdown-cadastro {
              top: 2.8125rem;
            }
          }
          .info-user {
            display: none;
          }
          .dropdown-cadastro {
            left: -2.375rem;
            &:before {
              margin-left: 4rem;
            }
          }
        }
        .favoritos {
          position: absolute;
          top: 1.4375rem;
          right: 7.8125rem;
        }
      }
    }
    .area-favorite {
      position: absolute;
      right: 4.8125rem;
      top: 0.9375rem;
    }
    .area-cart {
      position: absolute;
      right: 0;
      top: 1.0625rem;
      .dropdown-cart {
        left: initial;
        right: 0;
      }
      .btn-show-cart {
        width: 3.4375rem;
        height: 2.125rem;
        img {
          margin-right: 0.5625rem;
          max-width: 0.9375rem;
        }
        span {
          font-size: 0.875rem;
        }
      }
    }
    .search {
      position: absolute;
      left: 0;
      bottom: 1.9375rem;
      width: 100%;
      height: 2.5rem;
      button {
        width: 2rem;
        height: 2rem;
        img {
          max-width: 0.875rem;
        }
      }
      input {
        font-size: 0.875rem;
      }
    }
  }
  @media (max-width: 30rem) {
    height: 8.125rem;

    ${Container} {
      flex-direction: column;
    }

    .search {
      bottom: 1.625rem;
    }

    .box-parcela-loja {
      display: flex;
      justify-content: center;
      width: 5.125rem;
      font-size: 0.8125rem;
      color: #ffff;
      margin-bottom: 4.0625rem;
      padding: 0.5rem;
      text-align: center;
      margin-left: 2.1875rem;
      line-height: 1;
      background: rgba(93, 168, 255, 0.34);
      border-radius: 0.375rem;
    }
    .parcela-loja {
      display: none;
    }
  }
  @media (max-width: 23.75rem) {
    .dropdown-cart {
      right: -0.9375rem !important;
      width: 19.375rem !important;
      top: 2.8125rem !important;
    }

    .box-parcela-loja {
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 3.3125rem;
      width: 17.5rem;
      padding: 0.25rem;

      a {
        font-size: 0.6875rem;
      }
    }
  }
`

export const ContactArea = styled.div<ContactAreaProps>`
  cursor: pointer;
  display: flex;
  align-items: center;
  p {
    display: flex;
    align-items: center;
    font-size: 0.9375rem;
    line-height: 1.125rem;
    color: ${(props) =>
      props.textColor && props.textColor !== '' ? props.textColor : 'white'};
    img {
      margin-right: 0.625rem;
    }
    a {
      font-weight: 600;
      font-size: 0.9375rem;
      line-height: 1.125rem;
      color: ${(props) =>
        props.textColor && props.textColor !== '' ? props.textColor : 'white'};
      margin-right: 0.3125rem;
    }
  }
`
